import { TextWithLF } from '@doda/common/src/components/TextWithLF';
import { SectionItem } from '../../SectionItem';
import { SubSection } from '../../SubSection';
import styles from './index.module.scss';
/**
 * TreatmentAndWelfareのProps
 */
interface Props {
  treatmentAndWelfare: string;
  companyBenefits: string;
}

/**
 * 求人詳細・待遇・福利厚生
 */
export const TreatmentAndWelfare = ({
  treatmentAndWelfare,
  companyBenefits,
}: Props) => {
  return (
    <SectionItem label="待遇・福利厚生">
      <div className={styles['jobSearchDetail-treatmentAndWelfare__items']}>
        {treatmentAndWelfare && (
          <SubSection label="各種制度">
            <TextWithLF text={treatmentAndWelfare} />
          </SubSection>
        )}
        {companyBenefits && (
          <SubSection label="その他">
            <TextWithLF text={companyBenefits} />
          </SubSection>
        )}
      </div>
    </SectionItem>
  );
};
